module.exports = {"530324001":"罗雄街道","530324002":"腊山街道","530324003":"九龙街道","530324102":"板桥镇","530324103":"马街镇","530324104":"富乐镇","530324106":"阿岗镇","530324201":"大水井乡","530324202":"鲁布革布依族苗族乡","530324203":"旧屋基彝族乡","530324204":"钟山乡","530324205":"长底布依族乡","530324206":"老厂乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/530324.json
// module id = 2559
// module chunks = 0